import React, { useState } from 'react';
import Papa from 'papaparse';
import axios from 'axios';
import GLOBALVAR from '../constants'; // Import GLOBALVAR constant
import 'bootstrap/dist/css/bootstrap.min.css';

const ImportApplicant = () => {
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [isImporting, setIsImporting] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleImport = () => {
    if (!file) {
      alert('Please select a file first!');
      return;
    }

    setIsImporting(true);
    setProgress(0);

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (results) => {
        const data = results.data;
        const totalRows = data.length;

        for (let i = 0; i < totalRows; i++) {
          const row = data[i];
          // Prepare the payload for the API
          const payload = {
            firstName: row['First Name'] || 'Placeholder First Name',
            lastName: row['Last Name'] || 'Placeholder Last Name',
            middleName: row['Middle Name'] || '',
            mothersMaidenName: 'mothersMaidenName',
            street: 'street',
            barangay: 'barangay',
            municipality: 'municipality',
            province: 'province',
            zipCode: 'zipCode',
            birthday: '1900-01-01',
            gender: 'gender',
            civilStatus: 'civilStatus',
            marriedTo: 'marriedTo',
            telephoneNo: 'telephoneNo',
            mobileNo1: 'mobileNo1',
            mobileNo2: 'mobileNo2',
            emailAddress: 'email@address.com',
            sssOrGsis: 'sssOrGsis',
            passport: 'passport',
            employerDetails: 'employerDetails',
            employerAddress: 'employerAddress',
            employerContactNumber: 'employerContactNumber',
            employerLocation: 'employerLocation',
            is_deleted: false,
          };

          try {
            // Check if the application already exists
            const checkResponse = await axios.get(
              `${GLOBALVAR['SERVER_ROOT']}/api/applications/check`,
              {
                params: {
                  firstName: payload.firstName,
                  lastName: payload.lastName,
                },
              }
            );

            if (checkResponse.data.exists) {
              // Update existing application
              const updateResponse = await axios.post(
                `${GLOBALVAR['SERVER_ROOT']}/api/applications/update/${checkResponse.data.id}`,
                payload
              );
              console.log('Application updated successfully!', updateResponse.data);
            } else {
              // Create new application
              const createResponse = await axios.post(
                `${GLOBALVAR['SERVER_ROOT']}/api/applications/add`,
                payload
              );
              console.log('Application submitted successfully!', createResponse.data);
            }
          } catch (error) {
            console.error('Error processing application:', error);
          }

          setProgress(((i + 1) / totalRows) * 100);
        }

        setIsImporting(false);
        alert('CSV import complete!');
      },
    });
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card shadow-sm">
            <div className="card-body">
              <h1 className="card-title text-center">CSV Import</h1>
              <div className="form-group">
                <label htmlFor="csvFile">Upload CSV File</label>
                <input
                  type="file"
                  className="form-control-file"
                  id="csvFile"
                  accept=".csv"
                  onChange={handleFileChange}
                />
              </div>
              <button
                className="btn btn-primary btn-block mt-3"
                onClick={handleImport}
                disabled={isImporting}
              >
                {isImporting ? 'Importing...' : 'Import CSV'}
              </button>
              {isImporting && (
                <div className="progress mt-3">
                  <div
                    className="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    style={{ width: `${progress}%` }}
                    aria-valuenow={progress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {Math.round(progress)}%
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportApplicant;
